import { attachmentApi } from '@/store/services/attachment.service'
import { useEffect, useMemo } from 'react'
import {
  createSearchParams,
  generatePath,
  useLoaderData,
  useSearchParams
} from 'react-router-dom'
import {
  Button,
  Dialog,
  DialogBody,
  DialogFooter,
  DialogHeader
} from '@material-tailwind/react'
import { LinkWithQuery } from '@/shared/components/link-with-query'
import { Pill } from '@/shared/components/pill'
import { store } from '@/store'
import { AttachmentTableWithTabs } from '@/shared/components/attachments'
import { attachmentUpload, list } from '@/router/utils'
import { useAuthorization } from '@/hooks'
import { HasAccess } from '@permify/react-role'

export const AssetAttachmentList = () => {
  const { hasAccess } = useAuthorization({
    redirection: {
      enable: true
    }
  })
  const { asset } = useLoaderData()
  const [searchParams] = useSearchParams()
  const defaultSearchParams = useMemo(() => {
    const reloadToken = searchParams.get('attachment_reload')

    return {
      attachable_type: 'Contractor::Asset',
      attachable_id: asset.id,
      ...(reloadToken ? { attachment_reload: reloadToken } : {})
    }
  }, [asset.id, searchParams])

  const pillOptions = useMemo(() => {
    return []
  }, [asset])

  const getMore = async (searchParams) => {
    try {
      const {
        attachments = [], meta = {}
      } = await store.dispatch(
        attachmentApi.endpoints.getAttachments.initiate(`?${searchParams.toString()}`)
      ).unwrap()

      const currentPage = Number(searchParams.get('page'))
      const hasMore = currentPage < meta?.pagination?.total_pages

      return {
        attachments,
        hasMore
      }
    } catch (error) {
      console.log('error', error)
    }
  }

  useEffect(() => {
    hasAccess('asset#attachments')
  }, [])

  return (
    <Dialog size='xl' className='h-4/5' open={true}>
      <DialogHeader>Detalle de documentos subidos</DialogHeader>

      <DialogBody className='overflow-hidden' style={{ height: 'inherit' }}>
        <div className='flex gap-3 mb-5'>
          {!!pillOptions.length &&
            pillOptions.map(({ value, label }) => (
              <Pill key={value} label={label} value={value} />
            ))}
        </div>

        <AttachmentTableWithTabs
          initialSearchParams={defaultSearchParams}
          getMore={getMore}
          initialTab={searchParams.get('attachment_tab')}
          uploadPermission='asset#upload_attachments'
          buildUploadPath={(attachment, currentTab) =>
            generatePath(
              '/assets/:id/attachments/:attachmentId/upload_attachment',
              {
                id: asset.id,
                attachmentId: attachment.id
              }
            ) + `?${createSearchParams({
              ...Object.fromEntries(searchParams.entries()),
              attachment_tab: currentTab
            }).toString()}`
          }
        />
      </DialogBody>

      <DialogFooter className='flex gap-3'>
        <LinkWithQuery to={list('assets')}>
          <Button
            variant='outlined'
            color='white'
          >
            Volver
          </Button>
        </LinkWithQuery>

        <HasAccess permissions='asset#upload_attachments'>
          <LinkWithQuery to={attachmentUpload('assets', asset.id)}>
            <Button>
              Añadir documento
            </Button>
          </LinkWithQuery>
        </HasAccess>
      </DialogFooter>
    </Dialog>
  )
}
